export enum ChannelDisplayType {
  iframe = 'iframe',
  newTab = 'new_tab',
  modal = 'modal',
  newTabWithInfo = 'new_tab_with_info',
  modalWithInfo = 'modal_with_info',
}
